import ProfilePhoto, { Width } from "../../components/profilePhoto"
import { Platform, QuestionDetailFragment } from "../../graphql/generated/graphql"
import React from "react"
import tw, { styled } from "twin.macro"
import { FanData, getIconForPlatform } from "."
import { Button } from "../../components/formElements/button"
import router from "next/router"
import { Routes } from "../../routes"
import { ReactComponent as QuestionIcon } from "../../assets/icons/question.svg"
import { ReactComponent as AnswerIcon } from "../../assets/icons/answer.svg"

interface TopQuestionCardProps {
  question: QuestionDetailFragment
  fanData: FanData
  isFirst: boolean
  isLast: boolean
}

const CardWrapper = styled.div<{ isFirst: boolean; isLast: boolean }>`
  ${tw`border-2 mx-1 border-system-gray-1 rounded-lg`}
  ${({ isFirst }) => isFirst && tw`mr-2`}
  ${({ isLast }) => isLast && tw`ml-2`}
`

const IconWrapper = styled.div`
  position: relative;
`

const StyledIcon = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`

export const TopQuestionCard = ({ question, fanData, isFirst, isLast }: TopQuestionCardProps) => {
  const { id, body, Fan, platform } = question
  const { profilePictureUrl, verified, username, name } = Fan

  const platformIcon = getIconForPlatform(platform ?? Platform.WebClient, id)

  const questionCount = fanData.questions
  const answerCount = 0
  return (
    <CardWrapper isFirst={isFirst} isLast={isLast}>
      <IconWrapper>
        <StyledIcon>{platformIcon}</StyledIcon>
      </IconWrapper>
      <div tw="flex flex-col w-80 p-4">
        <div tw="flex items-center">
          <ProfilePhoto
            name={name ?? ""}
            username={username}
            width={Width.W60}
            profilePictureUrl={profilePictureUrl}
            showVerified={verified}
          />
          <div tw="px-2">
            <div tw="flex items-center space-x-5 tablet-lg:space-x-10">
              <span tw="title-4 text-md">{username}</span>
            </div>
            <div tw="flex items-center space-x-4 text-sm">
              <div tw="flex items-center">
                <QuestionIcon tw="w-4 h-4 mr-1" />
                <span tw="font-bold">{questionCount}</span>
              </div>
              <div tw="flex items-center">
                <AnswerIcon tw="w-4 h-4 mr-1" />
                <span tw="font-bold">{answerCount}</span>
              </div>
            </div>
          </div>
        </div>
        <div tw="flex flex-col border-2 border-base-1 rounded-lg p-2 mt-4 h-44 justify-between">
          <div>
            <p tw="text-xs text-base-3">Top question</p>
            <p tw="text-sm py-2">{body.slice(0, 100)}</p>
          </div>
        </div>
        <div tw="pt-6 flex justify-center">
          <Button
            tw="self-center w-full h-10"
            action="view question"
            onClickAsync={async () =>
              void router.push({
                pathname: Routes.ShowQuestion,
                query: { id },
              })
            }
          />
        </div>
      </div>
    </CardWrapper>
  )
}
